import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { OPACITY_13 } from 'constants/opacity';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';

export const CartBorder = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${calculateRgbaWithAlpha(
    theme.palette.sectionNav.link.main,
    OPACITY_13
  )}`,
  position: 'absolute',
  width: '100vw',
  left: -24,
  top: 0
}));
